<template>
  <div class="addOrAditVehicleDefault-container">
    <el-form
      inline
      ref="addDefault"
      :model="queryForm"
      :rules="addDefaultRules"
      label-position="left"
      label-width="130px"
    >
      <div class="once-form">
        <div class="title-text">车辆信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="车牌号：" prop="plateNum">
              <el-input
                v-model.trim="queryForm.plateNum"
                placeholder="请输入车牌号"
                @blur="getVehicleData(queryForm.plateNum)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车架号：" prop="vin">
              <el-input
                v-model.trim="queryForm.vin"
                placeholder="请输入车架号"
                :disabled="autocomplete"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="车辆绑定人：" prop="personnelName">
              <el-input
                v-model.trim="queryForm.personnelName"
                placeholder="请输入车辆绑定人"
                :disabled="autocomplete"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="车型：" prop="vehicleModel">
              <el-input
                v-model.trim="queryForm.vehicleModel"
                placeholder="请输入车型"
                :disabled="autocomplete"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="厂商型号：" prop="manufacturerModelId">
              <el-select
                v-model.trim="queryForm.manufacturerModelId"
                placeholder="请选择厂商型号"
              >
                <el-option
                  v-for="item in manufacturerModelList"
                  :key="item.code"
                  :label="item.value"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业名称：" prop="carCompanyId">
              <el-select
                v-model.trim="queryForm.carCompanyId"
                placeholder="请选择企业名称"
              >
                <el-option
                  v-for="item in carCompanyNameList"
                  :key="item.code"
                  :label="item.value"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="once-form">
        <div class="title-text">故障信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="故障类型：" prop="errorType">
              <el-select
                v-model.trim="queryForm.errorType"
                placeholder="请选择故障类型"
              >
                <el-option
                  v-for="item in errorTypeList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              class="happen-picker"
              label="发生时间："
              prop="occurrenceTime"
            >
              <el-date-picker
                v-model="queryForm.occurrenceTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择发生时间"
                :picker-options="timePickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="故障码：" prop="faultCode">
              <el-input
                v-model.trim="queryForm.faultCode"
                placeholder="请输入故障码"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col v-if="!deviceFlag">
            <el-form-item
              label="故障设备名称："
              prop="deviceName"
              class="longer-input"
            >
              <el-input
                v-model.trim="deviceName"
                placeholder="请输入故障设备名称，多个用英文逗号分割"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col v-else-if="deviceFlag">
            <el-form-item
              label="配件选择："
              prop="accessoriesId"
              class="longer-input"
            >
              <el-select
                v-model.trim="accessoriesId"
                multiple
                placeholder="请选择【配件名称:规格/代号/件号:主要参数】支持多选，英文逗号隔开"
                no-data-text="无数据，请去配件管理中添加"
                collapse-tags
                clearable
              >
                <el-option
                  v-for="item in errorEquipmentList"
                  :key="item.id"
                  :label="item.accessory"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="发生地点：" prop="scene" class="longer-input">
              <el-input
                type="textarea"
                placeholder="请输入发生地点"
                v-model.trim="queryForm.scene"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item
              label="故障现象描述："
              prop="errorDescription"
              class="longer-input"
            >
              <el-input
                type="textarea"
                v-model.trim="queryForm.errorDescription"
                placeholder="请输入故障现象描述"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="once-form">
        <div class="title-text">解决方案</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="处理类型：" prop="handlingType">
              <el-select
                v-model.trim="queryForm.handlingType"
                placeholder="请选择处理类型"
              >
                <el-option
                  v-for="item in handlingTypeList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="处理进度：" prop="handlingProgress">
              <el-select
                v-model.trim="queryForm.handlingProgress"
                placeholder="请选择处理进度"
              >
                <el-option
                  v-for="item in handlingProgressList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="处理方式：" prop="handlingMode">
              <el-select
                v-model.trim="queryForm.handlingMode"
                placeholder="请选择处理方式"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="item in handlingModeList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item
              label="解决方法："
              prop="solution"
              class="longer-input"
            >
              <el-input
                type="textarea"
                v-model.trim="queryForm.solution"
                placeholder="请输入解决方法"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="!handleFlag">
            <el-form-item
              class="happen-picker"
              label="处理时间："
              prop="handlingTime"
            >
              <el-date-picker
                v-model="queryForm.handlingTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择处理时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="!completeFlag">
            <el-form-item
              class="happen-picker"
              label="完成时间："
              value-format="yyyy-MM-dd HH:mm:ss"
              prop="completeTime"
            >
              <el-date-picker
                v-model="queryForm.completeTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择完成时间"
                :picker-options="timePickerOptions"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col v-if="prevTimeFlag">
            <el-form-item
              class="happen-picker"
              label="预处理时间："
              prop="prevHandleTime"
            >
              <el-date-picker
                v-model="prevHandleTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择预处理时间："
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item
            label="故障上传（支持最大上传10张照片或1个视频，单个照片最大不超过2MB，单个视频最大不超过25MB，至少一个照片或视频包含车牌号）："
            label-width="100%"
            prop="failureUpload"
            class="failureUpload"
          >
            <!-- 上传视频 -->
            <el-upload
              ref="failureVideoUpload"
              action="#"
              accept=".mp4"
              list-type="picture-card"
              :auto-upload="false"
              :on-change="handleFailureVideoChange"
              :limit="1"
              class="normal-uploader"
              :file-list="errVideoFileList"
            >
              <el-button type="primary" v-if="!classFlag">{{
                errVideoText
              }}</el-button>
              <el-button
                type="primary"
                v-if="clearVideoFlag"
                @click.stop="clearVideo()"
                >清空视频</el-button
              >
              <div slot="file" slot-scope="{ file }">
                <video :src="file.url" width="180" height="120"></video>
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                </span>
              </div>
            </el-upload>
            <el-dialog
              :visible.sync="videoDialogVisible"
              append-to-body
              class="upload-dialog"
              @close="errVideoClose(1)"
            >
              <video controls width="100%" :src="videoUrl" ref="errVideo">
                <source :src="videoUrl" type="video/webm" />
                您的浏览器不支持 video 标签
              </video>
            </el-dialog>
            <!-- 上传编辑维保店 -->
            <el-upload
              ref="failureImgUpload"
              action="#"
              accept=".jpg,.jpeg,.png"
              list-type="picture-card"
              :auto-upload="false"
              :on-preview="handlePreview"
              :on-change="handleFailureImgChange"
              :limit="10"
              class="normal-uploader"
              :file-list="errImgFileList"
            >
              <el-button type="primary" v-if="!classFlagImg">{{
                errImgText
              }}</el-button>
              <el-button
                type="primary"
                v-if="clearImgFlag"
                @click.stop="clearImg()"
                >清空图片</el-button
              >
            </el-upload>
            <el-dialog
              :visible.sync="imageDialogVisible"
              append-to-body
              class="upload-dialog"
            >
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
        </el-row>
      </div>
      <div class="once-form">
        <div class="title-text">上次（安装）处理人员信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="单位名称：" prop="lastHandlerCompany">
              <el-input
                placeholder="请输入单位名称"
                v-model.trim="queryForm.lastHandlerCompany"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话：" prop="lastHandlerPhone">
              <el-input
                placeholder="请输入电话"
                v-model.trim="queryForm.lastHandlerPhone"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="姓名：" prop="lastHandlerName">
              <el-input
                placeholder="请输入姓名"
                v-model.trim="queryForm.lastHandlerName"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="once-form">
        <div class="title-text">本次处理人员信息</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="单位名称：" prop="handlerCompany">
              <el-input
                placeholder="请输入单位名称"
                v-model.trim="queryForm.handlerCompany"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电话：" prop="handlerPhone">
              <el-input
                placeholder="请输入电话"
                v-model.trim="queryForm.handlerPhone"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="姓名：" prop="handlerName">
              <el-input
                placeholder="请输入姓名"
                v-model.trim="queryForm.handlerName"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item
            label="上传处理后照片或视频（支持最大上传10张照片或1个视频，单个照片最大不超过2MB，单个视频最大不超过25MB，至少一个照片或视频包含车牌号）："
            label-width="100%"
            prop="failureResultUpload"
            ref="failureResultUpload"
          >
            <!-- 上传视频 -->
            <el-upload
              ref="failureResultVideoUpload"
              action="#"
              list-type="picture-card"
              :auto-upload="false"
              :on-change="handleFailureResultVideoChange"
              :limit="1"
              class="normal-uploader"
              :file-list="handlingVideoFileList"
            >
              <el-button type="primary" v-if="!classFlag1">{{
                handlingVideoText
              }}</el-button>
              <el-button
                type="primary"
                v-if="clearVideoFlag1"
                @click.stop="clearVideo1()"
                >清空视频</el-button
              >
              <div slot="file" slot-scope="{ file }">
                <video :src="file.url" width="180" height="120"></video>
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handleResultPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                </span>
              </div>
            </el-upload>
            <el-dialog
              :visible.sync="videoDialogVisible1"
              append-to-body
              class="upload-dialog"
              @close="errVideoClose(2)"
            >
              <video controls width="100%" :src="videoUrl1" ref="errVideo1">
                <source :src="videoUrl1" type="video/webm" />
                您的浏览器不支持 video 标签
              </video>
            </el-dialog>
            <!-- 上传图片 -->
            <el-upload
              ref="failureResultImgUpload"
              action="#"
              list-type="picture-card"
              :auto-upload="false"
              :on-preview="handleResultPreview"
              :on-change="handleFailureResultImgChange"
              :limit="10"
              class="normal-uploader"
              :file-list="handlingImgFileList"
            >
              <el-button type="primary" v-if="!classFlagImg1">{{
                handlingImgText
              }}</el-button>
              <el-button
                type="primary"
                v-if="clearImgFlag1"
                @click.stop="clearImg1()"
                >清空图片</el-button
              >
            </el-upload>
            <el-dialog
              :visible.sync="imageDialogVisible1"
              append-to-body
              class="upload-dialog"
            >
              <img width="100%" :src="dialogImageUrl1" alt="" />
            </el-dialog>
          </el-form-item>
        </el-row>
      </div>
      <div class="once-form">
        <div class="title-text">上传附件</div>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="上传清单（请上传维修更换的清单，最大支持上传5张照片，单个照片不超过2MB）："
              label-width="100%"
              prop="inventorys"
            >
              <el-upload
                ref="uploadList"
                action="#"
                list-type="picture-card"
                :auto-upload="false"
                class="normal-uploader"
                :limit="5"
                :on-preview="handleListPreview"
                :on-change="handleListChange"
                :file-list="inventorysImgFileList"
              >
                <el-button type="primary" v-if="!listFlag">{{
                  listImgText
                }}</el-button>
                <el-button
                  type="primary"
                  v-if="clearImgFlag2"
                  @click.stop="clearImg2()"
                  >清空清单</el-button
                >
              </el-upload>
              <el-dialog
                :visible.sync="imageListVisible"
                class="upload-dialog"
                append-to-body
              >
                <img width="100%" :src="dialogListImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="上传票据（请上传维修更换的发票或收据，最大支持上传2张照片，单个照片不超过2MB）："
              label-width="100%"
              prop="bills"
            >
              <el-upload
                ref="uploadBill"
                action="#"
                list-type="picture-card"
                :auto-upload="false"
                class="normal-uploader"
                :limit="2"
                :on-preview="handleBillPreview"
                :on-change="handleBillChange"
                :file-list="billImgFileList"
              >
                <el-button type="primary" v-if="!billFlag">{{
                  billImgText
                }}</el-button>
                <el-button
                  type="primary"
                  v-if="clearImgFlag3"
                  @click.stop="clearImg3()"
                  >清空票据</el-button
                >
              </el-upload>
              <el-dialog
                :visible.sync="imageBillVisible"
                class="upload-dialog"
                append-to-body
              >
                <img width="100%" :src="dialogBillImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div class="add-footer">
      <el-button type="primary" @click="uploadSaveOrUpdate()">确认</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddOrAditVehicleDefault",
  props: ["closeDialog", "editId", "edit", "autocomplete"],
  data() {
    const checkPlateNum = (rule, value, callback) => {
      if (!value || this.plateNumFlag) {
        callback(new Error("请输入正确的车牌号！"));
      } else {
        callback();
      }
    };
    const checkFileUpload = (rule, value, callback) => {
      if (
        this.imgOrVideoFileList.length > 0 ||
        this.queryForm.errorImgsUrl != ""
      ) {
        callback();
      } else {
        callback(new Error("请完成上传照片或者视频"));
      }
    };
    const deviceNameValidator = (rule, value, callback) => {
      if (this.queryForm.errorType === 1) {
        // 其他故障
        if (this.deviceName != "") {
          callback();
        } else {
          callback(new Error("请输入故障设备名称，多个用英文逗号分割"));
        }
      } else {
        if (this.accessoriesId.length > 0) {
          callback();
        } else {
          callback(
            new Error("请选择【配件名称:规格/代号/件号:主要参数】支持多选")
          );
        }
      }
    };
    const handlingTimeValidator = (rule, value, callback) => {
      if (this.prevHandleTime != "") {
        callback();
      } else {
        callback(new Error("请选择预处理时间"));
      }
    };
    const checkResultFileUpload = (rule, value, callback) => {
      if (this.queryForm.handlingProgress == 2) {
        if (
          this.handlingFileList.length > 0 ||
          this.queryForm.handlingImgsUrl != ""
        ) {
          callback();
        } else {
          callback(new Error("请完成上传照片或者视频"));
        }
      } else {
        callback();
      }
    };
    return {
      queryForm: {
        plateNum: "",
        vin: "",
        personnelName: "",
        personnelId: null,
        vehicleModel: "",
        manufacturerModelId: null,
        carCompanyId: null,
        errorType: null,
        occurrenceTime: null,
        errorEquipment: "",
        errorDescription: "",
        handlingType: null, // 处理类型
        handlingProgress: null,
        handlingMode: null, // 处理方式
        solution: "",
        faultCode: "",
        handlingTime: null,
        completeTime: null,
        scene: "",
        lastHandlerCompany: "",
        lastHandlerName: "",
        lastHandlerPhone: "",
        handlerCompany: "",
        handlerName: "",
        handlerPhone: "",
        errorImgsUrl: "",
        handlingImgsUrl: "",
        inventorysUrl: "",
        billsUrl: "",
      },
      plateNumFlag: false,
      errVideoText: "上传视频",
      errImgText: "上传图片",
      handlingVideoText: "上传视频",
      handlingImgText: "上传图片",
      listImgText: "上传清单",
      billImgText: "上传票据",
      deviceName: "",
      accessoriesId: [],
      prevHandleTime: "",
      classFlag: false,
      classFlag1: false,
      listFlag: false,
      billFlag: false,
      classFlagImg: false,
      classFlagImg1: false,
      videoDialogVisible: false,
      videoDialogVisible1: false,
      imageDialogVisible: false,
      imageDialogVisible1: false,
      imageBillVisible: false,
      imageListVisible: false,
      prevTimeFlag: false,
      completeFlag: false,
      handleFlag: false,
      deviceFlag: false,
      dialogImageUrl: "",
      dialogImageUrl1: "",
      dialogListImageUrl: "",
      dialogBillImageUrl: "",
      videoUrl: "",
      videoUrl1: "",
      imgOrVideoFileList: [],
      handlingFileList: [],
      inventorysFileList: [],
      billsFileList: [],
      errorImgs: [],
      handlingImgs: [],
      inventorys: [],
      bills: [],
      addDefaultRules: {
        plateNum: [
          { required: true, trigger: "blur", validator: checkPlateNum },
        ],
        manufacturerModelId: [
          { required: true, trigger: "blur", message: "请输入厂商型号" },
        ],
        carCompanyId: [
          { required: true, trigger: "blur", message: "请输入企业名称" },
        ],
        errorType: [
          { required: true, trigger: "blur", message: "请选择故障类型" },
        ],
        occurrenceTime: [
          { required: true, trigger: "blur", message: "请选择发生时间" },
        ],
        deviceName: [
          {
            required: true,
            trigger: "blur",
            validator: deviceNameValidator,
          },
        ],
        accessoriesId: [
          {
            required: true,
            trigger: "blur",
            validator: deviceNameValidator,
          },
        ],
        errorDescription: [
          { required: true, trigger: "blur", message: "请输入故障现象描述" },
        ],
        handlingType: [
          { required: true, trigger: "blur", message: "请选择处理类型" },
        ],
        handlingProgress: [
          { required: true, trigger: "blur", message: "请选择处理进度" },
        ],
        handlingMode: [
          { required: true, trigger: "blur", message: "请选择处理方式" },
        ],
        solution: [
          { required: true, trigger: "blur", message: "请输入解决方法" },
        ],
        handlingTime: [
          { required: true, trigger: "blur", message: "请选择处理时间" },
        ],
        prevHandleTime: [
          {
            required: true,
            trigger: "blur",
            validator: handlingTimeValidator,
          },
        ],
        completeTime: [
          { required: true, trigger: "blur", message: "请选择完成时间" },
        ],
        scene: [{ required: true, trigger: "blur", message: "请输入发生地点" }],
        failureUpload: [
          {
            required: true,
            trigger: "blur",
            validator: checkFileUpload,
          },
        ],
        failureResultUpload: [
          {
            required: false,
            trigger: "blur",
            validator: checkResultFileUpload,
          },
        ],
        handlerCompany: [
          { required: false, trigger: "blur", message: "请输入单位名称" },
        ],
        handlerPhone: [
          { required: false, trigger: "blur", message: "请输入电话" },
        ],
        handlerName: [
          { required: false, trigger: "blur", message: "请输入姓名" },
        ],
      },
      errorTypeList: [
        { id: 0, label: "配件故障", value: 0 },
        { id: 1, label: "其他故障", value: 1 },
      ],
      handlingProgressList: [
        { id: 0, label: "待处理", value: 0 },
        { id: 1, label: "处理中", value: 1 },
        { id: 2, label: "处理完成", value: 2 },
      ],
      handlingTypeList: [
        { id: 0, label: "维修", value: 0 },
        { id: 1, label: "更换", value: 1 },
      ],
      handlingModeList: [
        { id: 0, label: "到店处理", value: 0 },
        { id: 1, label: "返厂处理", value: 1 },
        { id: 2, label: "上门处理", value: 2 },
        { id: 3, label: "其他处理", value: 3 },
      ],
      errorEquipmentList: [],
      carCompanyNameList: [],
      manufacturerModelList: [],
      timePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      errVideoFileList: [],
      errImgFileList: [],
      handlingVideoFileList: [],
      handlingImgFileList: [],
      inventorysImgFileList: [],
      billImgFileList: [],
      clearVideoFlag: false,
      clearImgFlag: false,
      clearVideoFlag1: false,
      clearImgFlag1: false,
      clearImgFlag2: false,
      clearImgFlag3: false,
      loading: false,
      handlingTime: null,
    };
  },
  watch: {
    "queryForm.handlingProgress": {
      handler: function(val) {
        if (val === 0) {
          // 预处理时间就是后端返回的处理时间
          this.prevHandleTime = this.edit ? this.handlingTime : "";
          //  清空处理时间和完成时间
          this.queryForm.handlingTime = "";
          this.queryForm.completeTime = "";
          this.handleFlag = true;
          this.completeFlag = true;
          // 显示预处理时间
          this.prevTimeFlag = true;
          // 本次处理人员信息、上传处理后照片或视频均为非必填项
          this.addDefaultRules.handlerCompany[0].required = false;
          this.addDefaultRules.handlerPhone[0].required = false;
          this.addDefaultRules.handlerName[0].required = false;
          this.addDefaultRules.failureResultUpload[0].required = false;
        } else if (val == 1) {
          // 清空预处理时间和完成时间
          this.handlingTime = "";
          this.queryForm.completeTime = "";
          // 显示处理时间
          this.handleFlag = false;
          this.completeFlag = true;
          this.prevTimeFlag = false;
          // 本次处理人员信息必填符号显示、上传处理后照片或视频为非必填项
          this.addDefaultRules.handlerCompany[0].required = true;
          this.addDefaultRules.handlerPhone[0].required = true;
          this.addDefaultRules.handlerName[0].required = true;
          this.addDefaultRules.failureResultUpload[0].required = false;
        } else if (val == 2) {
          // 清空预处理时间
          this.handlingTime = "";
          // 显示处理时间
          this.handleFlag = false;
          // 显示完成时间
          this.completeFlag = false;
          this.prevTimeFlag = false;
          // 本次处理人员信息和上传处理后照片或视频均为必填项
          this.addDefaultRules.handlerCompany[0].required = true;
          this.addDefaultRules.handlerPhone[0].required = true;
          this.addDefaultRules.handlerName[0].required = true;
          this.addDefaultRules.failureResultUpload[0].required = true;
        }
      },
      deep: true,
    },
    "queryForm.errorType": {
      handler: function(val) {
        if (val === 1) {
          this.deviceFlag = false;
          this.accessoriesId = [];
        } else {
          this.deviceFlag = true;
          this.deviceName = "";
        }
      },
      deep: true,
      immediate: true,
    },
    closeDialog: {
      handler: function(val) {
        if (!val) {
          // 关闭弹框移除校验和清楚数据
          this.reset();
        } else {
          this.getEditDataList();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getManufacturerModel();
    this.getCarCompany();
  },
  methods: {
    errVideoClose(val) {
      if (val === 1) {
        this.$refs.errVideo.pause();
      } else if (val === 2) {
        this.$refs.errVideo1.pause();
      }
    },
    // 配件列表数据
    async getVehicleModelList(id) {
      let { data: res } = await this.$axios.get(
        "/api/error/recording/getModelAccessory",
        {
          params: { vehicleModelId: id },
        }
      );
      if (res.code == 1) {
        this.errorEquipmentList = res.data;
      } else {
        this.$message.error(res.msg);
      }
    },
    // 获取车型id、车架号等信息
    async getVehicleData(num) {
      let { data: res } = await this.$axios.get(
        "/api/error/recording/getVehicleSimple",
        {
          params: { plateNum: num },
        }
      );
      if (res.code == 1) {
        this.queryForm.personnelId = res.data.personnelId;
        this.queryForm.personnelName = res.data.personnelName;
        this.queryForm.vehicleModel = res.data.vehicleModel;
        this.queryForm.vin = res.data.vin;
        if (Object.keys(res.data).length != 0) {
          this.plateNumFlag = false;
          // 车牌号输入正确，取消校验
          this.$refs.addDefault.clearValidate("plateNum");
          this.getVehicleModelList(res.data.vehicleModelId);
        } else {
          this.getVehicleModelList(-1);

          this.plateNumFlag = true;
          // 触发车牌号校验
          this.$refs.addDefault.validateField("plateNum");
        }
      } else {
        this.$message.warning("请输入正确的车牌号！");
      }
    },
    // 检查文件按钮显示状态
    checkFileStatus(file) {
      let videoFlag = false;
      let imgFlag = false;
      if (file != "") {
        let video = this.changUploadFile(file, 1);
        let img = this.changUploadFile(file);
        if (video != "") {
          videoFlag = true;
        } else {
          videoFlag = false;
        }
        if (img != "") {
          imgFlag = true;
        } else {
          imgFlag = false;
        }
        this.errVideoText = this.$options.data().errVideoText;
        this.errImgText = this.$options.data().errImgText;
        this.handlingVideoText = this.$options.data().handlingVideoText;
        this.handlingImgText = this.$options.data().handlingImgText;
        this.listImgText = this.$options.data().listImgText;
        this.billImgText = this.$options.data().billImgText;
        return { videoFlag, imgFlag };
      } else {
        return { videoFlag, imgFlag };
      }
    },
    // 处理拿到的文件url数据
    changUploadFile(url, type) {
      let videoList = url.split(",");
      let imgList = url.split(",");
      let typeVideoList = [];
      let typeImgList = [];
      if (type == 1) {
        // 过滤得到视频文件
        typeVideoList = videoList.filter((item) => item.match(/([Mm][Pp]4)$/g));
        return typeVideoList.join(",");
      } else {
        // 过滤得到图片文件
        typeImgList = imgList.filter((item) => item.match(/(jpg|jpeg|png)/gi));
        return typeImgList.join(",");
      }
    },
    async getEditDataList() {
      let { data: res } = await this.$axios.get(
        "/api/error/recording/selectOne",
        {
          params: { id: this.editId },
        }
      );
      if (res.code == 1) {
        this.queryForm = Object.assign({}, { ...res.data });
        if (Object.keys(res.data).length == 0) {
          // 新增，清空数据
          this.clearVideoFlag = false;
          this.clearImgFlag = false;
          this.clearVideoFlag1 = false;
          this.clearImgFlag1 = false;
          this.clearImgFlag2 = false;
          this.clearImgFlag3 = false;
          this.queryForm = this.$options.data().queryForm;
        } else {
          // 编辑
          // 控制清楚按钮
          let {
            videoFlag: clearVideoFlag,
            imgFlag: clearImgFlag,
          } = this.checkFileStatus(res.data.errorImgsUrl);
          this.clearVideoFlag = clearVideoFlag;
          this.clearImgFlag = clearImgFlag;
          let {
            videoFlag: clearVideoFlag1,
            imgFlag: clearImgFlag1,
          } = this.checkFileStatus(res.data.handlingImgsUrl);
          this.clearVideoFlag1 = clearVideoFlag1;
          this.clearImgFlag1 = clearImgFlag1;
          let { imgFlag: clearImgFlag2 } = this.checkFileStatus(
            res.data.inventorysUrl
          );
          this.clearImgFlag2 = clearImgFlag2;
          let { imgFlag: clearImgFlag3 } = this.checkFileStatus(
            res.data.billsUrl
          );
          this.clearImgFlag3 = clearImgFlag3;
          let {
            videoFileList: video1,
            imgFileList: img1,
          } = this.tidyFilePreview(res.data.errorImgsUrlList);
          this.errVideoFileList = [...video1];
          this.errImgFileList = [...img1];
          let {
            videoFileList: video2,
            imgFileList: img2,
          } = this.tidyFilePreview(res.data.handlingImgsUrlList);
          this.handlingVideoFileList = [...video2];
          this.handlingImgFileList = [...img2];
          let { imgFileList: img3 } = this.tidyFilePreview(
            res.data.inventorysUrlList
          );
          this.inventorysImgFileList = [...img3];
          let { imgFileList: img4 } = this.tidyFilePreview(
            res.data.billsUrlList
          );
          this.billImgFileList = [...img4];
          this.getVehicleModelList(res.data.vehicleModelId);
          if (res.data.errorEquipment && res.data.errorType == 0) {
            this.accessoriesId = res.data.errorEquipment.split(",").map(Number);
          } else {
            this.deviceName = res.data.errorEquipment;
          }
          if (res.data.handlingProgress == 0) {
            this.handlingTime = res.data.handlingTime;
          } else if (res.data.handlingProgress == 1) {
            this.queryForm.handlingTime = res.data.handlingTime;
          } else if (res.data.handlingProgress == 2) {
            this.queryForm.handlingTime = res.data.handlingTime;
            this.queryForm.completeTime = res.data.completeTime;
          }
          if (this.errVideoFileList.length >= 3) {
            this.classFlag = true;
          } else {
            this.classFlag = false;
          }
          if (this.errImgFileList.length >= 10) {
            this.classFlagImg = true;
          } else {
            this.classFlagImg = false;
          }
          if (this.handlingVideoFileList.length >= 3) {
            this.classFlag1 = true;
          } else {
            this.classFlag1 = false;
          }
          if (this.handlingImgFileList.length >= 10) {
            this.classFlagImg1 = true;
          } else {
            this.classFlagImg1 = false;
          }
          if (this.errVideoFileList.length > 0) {
            this.errVideoText = "重新上传视频";
          }
          if (this.errImgFileList.length > 0) {
            this.errImgText = "重新上传图片";
          }
          if (this.handlingVideoFileList.length > 0) {
            this.handlingVideoText = "重新上传视频";
          }
          if (this.handlingImgFileList.length > 0) {
            this.handlingImgText = "重新上传图片";
          }
          if (this.inventorysImgFileList.length > 0) {
            this.listImgText = "重新上传清单";
          }
          if (this.billImgFileList.length > 0) {
            this.billImgText = "重新上传票据";
          }
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    // 整理文件数据预览
    tidyFilePreview(fileList) {
      let img = [];
      let video = [];
      let videoFileList = [];
      let imgFileList = [];
      if (fileList.length > 0) {
        let length = fileList.length;
        for (let i = 0; i < length; i++) {
          let type = fileList[i].substring(fileList[i].lastIndexOf(".") + 1);
          let name = fileList[i].substring(fileList[i].lastIndexOf("/") + 1);
          if (type == "mp4") {
            video.push({
              name: name,
              url: fileList[i],
            });
          } else {
            img.push({
              name: name,
              url: fileList[i],
            });
          }
        }
        // setTimeout(() => {
        videoFileList = video;
        imgFileList = img;
        // }, 350);
      }
      return { videoFileList, imgFileList };
    },
    // 处理上传数据
    handleUploadData() {
      this.errorImgs = [];
      this.handlingImgs = [];
      this.inventorys = [];
      this.bills = [];
      this.imgOrVideoFileList.forEach((item) => {
        this.errorImgs.push(item.raw);
      });
      this.handlingFileList.forEach((item) => {
        this.handlingImgs.push(item.raw);
      });
      this.inventorysFileList.forEach((item) => {
        this.inventorys.push(item.raw);
      });
      this.billsFileList.forEach((item) => {
        this.bills.push(item.raw);
      });
      if (this.queryForm.errorType === 1) {
        if (this.deviceName != "") {
          this.queryForm.errorEquipment = this.deviceName;
        }
      } else {
        if (this.accessoriesId.length > 0) {
          this.queryForm.errorEquipment = this.accessoriesId.join(",");
        }
      }
      if (this.queryForm.handlingProgress == 0) {
        this.queryForm.handlingTime = this.prevHandleTime;
      }
      if (this.imgOrVideoFileList.length > 0) {
        // 有新文件上传，置空
        this.queryForm.errorImgsUrl = "";
      }
      if (this.handlingFileList.length > 0) {
        // 有新文件上传，置空
        this.queryForm.handlingImgsUrl = "";
      }
      if (this.inventorysFileList.length > 0) {
        // 有新文件上传，置空
        this.queryForm.inventorysUrl = "";
      }
      if (this.billsFileList.length > 0) {
        // 有新文件上传，置空
        this.queryForm.billsUrl = "";
      }
    },
    // 提交表单
    async uploadSaveOrUpdate() {
      this.handleUploadData();
      let obj = new FormData();
      obj.append("entity", JSON.stringify(this.queryForm));
      this.imgOrVideoFileList.forEach((val) => {
        obj.append("errorImgs", val.raw);
      });
      this.handlingFileList.forEach((val) => {
        obj.append("handlingImgs", val.raw);
      });
      this.inventorysFileList.forEach((val) => {
        obj.append("inventorys", val.raw);
      });
      this.billsFileList.forEach((val) => {
        obj.append("bills", val.raw);
      });
      this.$refs.addDefault.validate(async (valid) => {
        if (valid) {
          // 表单验证通过就开启loading
          const loading = this.$loading({
            lock: true,
            text: "文件上传中，请等待...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          if (this.edit) {
            // 修改确定
            console.log("修改");
            let { data: res } = await this.$axios.put(
              "/api/error/recording/update",
              obj
            );
            if (res.code == 1) {
              // 关闭loading
              loading.close();
              // 关闭弹框，刷新分页数据
              this.$emit("close");
              this.$message.success(res.msg);
            } else {
              this.$message.warning(res.msg);
            }
          } else {
            // 新增确定
            console.log("新增");
            let { data: res } = await this.$axios.post(
              "/api/error/recording/insert",
              obj
            );
            if (res.code == 1) {
              // 关闭loading
              loading.close();
              // 关闭弹框，刷新分页数据
              this.$emit("close");
              this.$message.success(res.msg);
            } else {
              this.$message.warning(res.msg);
            }
          }
        }
      });
    },
    // 弹框取消操作
    reset() {
      // 新增弹框打开清除所有数据
      // 清除校验  清空表单数据
      this.$resetForm(this, "queryForm");
      this.deviceName = "";
      this.accessoriesId = [];
      this.prevHandleTime = "";
      this.$refs.addDefault.resetFields();
      // 清空文件列表
      this.imgOrVideoFileList = [];
      this.handlingFileList = [];
      this.inventorysFileList = [];
      this.billsFileList = [];
      this.$refs.failureVideoUpload.clearFiles();
      this.$refs.failureImgUpload.clearFiles();
      this.$refs.failureResultVideoUpload.clearFiles();
      this.$refs.failureResultImgUpload.clearFiles();
      this.$refs.uploadList.clearFiles();
      this.$refs.uploadBill.clearFiles();
    },
    cancel() {
      // 关闭弹框
      this.$emit("close");
    },
    clearVideo() {
      this.$refs.failureVideoUpload.clearFiles();
      // 清除视频留下图片
      this.queryForm.errorImgsUrl = this.changUploadFile(
        this.queryForm.errorImgsUrl
      );
      this.errVideoFileList = [];
      // 过滤掉视频文件
      this.imgOrVideoFileList = this.imgOrVideoFileList.filter((item) =>
        item.name.match(/(jpg|jpeg|png)/gi)
      );
      this.clearVideoFlag = false;
      this.classFlag = false;
      this.errVideoText = "重新上传视频";
    },
    clearImg() {
      this.$refs.failureImgUpload.clearFiles();
      this.queryForm.errorImgsUrl = this.changUploadFile(
        this.queryForm.errorImgsUrl,
        1
      );
      this.errImgFileList = [];
      // 留下视频文件，清除图片文件
      this.imgOrVideoFileList = this.imgOrVideoFileList.filter((item) =>
        item.name.match(/(mp4)$/gi)
      );
      this.clearImgFlag = false;
      this.classFlagImg = false;
      this.errImgText = "重新上传图片";
    },
    clearVideo1() {
      this.$refs.failureResultVideoUpload.clearFiles();
      // 清除视频留下图片
      this.queryForm.handlingImgsUrl = this.changUploadFile(
        this.queryForm.handlingImgsUrl
      );
      this.handlingVideoFileList = [];
      // 新增时清除视频会将已上传的图片一起清除，所以需要过滤
      // this.handlingFileList = [];
      // 过滤掉视频文件
      this.handlingFileList = this.handlingFileList.filter((item) =>
        item.name.match(/(jpg|jpeg|png)/gi)
      );
      this.clearVideoFlag1 = false;
      this.classFlag1 = false;
      this.handlingVideoText = "重新上传视频";
    },
    clearImg1() {
      this.$refs.failureResultImgUpload.clearFiles();
      this.queryForm.handlingImgsUrl = this.changUploadFile(
        this.queryForm.handlingImgsUrl,
        1
      );
      this.handlingImgFileList = [];
      // 留下视频文件，清除图片文件
      this.handlingFileList = this.handlingFileList.filter((item) =>
        item.name.match(/(mp4)$/gi)
      );
      this.clearImgFlag1 = false;
      this.classFlagImg1 = false;
      this.handlingImgText = "重新上传图片";
    },
    clearImg2() {
      this.$refs.uploadList.clearFiles();
      this.queryForm.inventorysUrl = "";
      this.inventorysUrlList = [];
      this.inventorysFileList = [];
      this.clearImgFlag2 = false;
      this.listFlag = false;
      this.listImgText = "重新上传清单";
    },
    clearImg3() {
      this.$refs.uploadBill.clearFiles();
      this.queryForm.billsUrl = "";
      this.billsUrlList = [];
      this.billsFileList = [];
      this.clearImgFlag3 = false;
      this.billFlag = false;
      this.billImgText = "重新上传票据";
    },

    // 获取厂商型号列表数据
    async getManufacturerModel() {
      let { data: res } = await this.$axios.get(
        "/api/sys/dict/manufacturerModel"
      );
      if (res.code == 1) {
        this.manufacturerModelList = res.data;
      }
    },
    // 获取企业名称数据
    async getCarCompany() {
      let { data: res } = await this.$axios.get("/api/sys/dict/carCompany");
      if (res.code == 1) {
        this.carCompanyNameList = res.data;
      }
    },
    handleListPreview(file) {
      this.dialogListImageUrl = file.url;
      this.imageListVisible = true;
    },
    handleBillPreview(file) {
      this.dialogBillImageUrl = file.url;
      this.imageBillVisible = true;
    },
    // 上传清单
    handleListChange(file, fileList) {
      this.inventorysFileList.push(file);
      this.uploadImage(file, fileList, this.inventorysFileList);
      if (this.inventorysImgFileList.length > 0) {
        this.listImgText = "重新上传清单";
      } else {
        this.listImgText = "上传清单";
      }
      if (fileList.length >= 5) {
        this.listFlag = true;
      } else {
        this.listFlag = false;
      }
      // 清空文件列表未满足要求的文件，判断清除按钮的显示与隐藏
      if (fileList.length > 0) {
        // 显示清除按钮
        this.clearImgFlag2 = true;
      } else {
        this.clearImgFlag2 = false;
      }
    },
    // 上传票据
    handleBillChange(file, fileList) {
      this.billsFileList.push(file);
      this.uploadImage(file, fileList, this.billsFileList);
      if (this.billImgFileList.length > 0) {
        this.billImgText = "重新上传票据";
      } else {
        this.billImgText = "上传票据";
      }
      if (fileList.length >= 2) {
        this.billFlag = true;
      } else {
        this.billFlag = false;
      }
      // 清空文件列表未满足要求的文件，判断清除按钮的显示与隐藏
      if (fileList.length > 0) {
        // 显示清除按钮
        this.clearImgFlag3 = true;
      } else {
        this.clearImgFlag3 = false;
      }
    },
    /** 故障上传照片/视频 start */
    handleFailureVideoChange(file, fileList) {
      // 上传成功文件列表
      this.imgOrVideoFileList.push(file);
      // 删除不满足文件条件的
      this.uploadVideo(file, fileList, this.imgOrVideoFileList);
      if (this.errVideoFileList.length > 0) {
        this.errVideoText = "重新上传视频";
      } else {
        this.errVideoText = "上传视频";
      }
      if (fileList.length >= 1) {
        this.classFlag = true;
      } else {
        this.classFlag = false;
      }
      // 清空文件列表未满足要求的文件，判断清除按钮的显示与隐藏
      if (fileList.length > 0) {
        // 显示清除按钮
        this.clearVideoFlag = true;
      } else {
        this.clearVideoFlag = false;
      }
    },
    handleFailureImgChange(file, fileList) {
      // 上传成功文件列表
      this.imgOrVideoFileList.push(file);
      this.uploadImage(file, fileList, this.imgOrVideoFileList);
      if (this.errImgFileList.length > 0) {
        this.errImgText = "重新上传图片";
      } else {
        this.errImgText = "上传图片";
      }
      if (fileList.length > 0) {
        // 显示清除按钮
        this.clearImgFlag = true;
      } else {
        this.clearImgFlag = false;
      }
      // 控制上传按钮隐藏
      if (fileList.length >= 10) {
        this.classFlagImg = true;
      } else {
        this.classFlagImg = false;
      }
    },
    /** 故障上传照片/视频 end */
    deleteFile(file, fileList) {
      for (let i in fileList) {
        // 上传的这个file匹配到上传列表中的img，这一项不满足要求需要删除
        if (file == fileList[i]) {
          fileList.splice(i, 1);
        }
      }
    },

    /** 故障处理后上传照片/视频 start */
    handleFailureResultVideoChange(file, fileList) {
      this.handlingFileList.push(file);
      this.uploadVideo(file, fileList, this.handlingFileList);
      if (fileList.length > 0) {
        // 显示清除按钮
        this.clearVideoFlag1 = true;
      } else {
        this.clearVideoFlag1 = false;
      }
      if (this.handlingVideoFileList.length > 0) {
        this.handlingVideoText = "重新上传视频";
      } else {
        this.handlingVideoText = "上传视频";
      }
      // 控制上传按钮隐藏
      if (fileList.length >= 1) {
        this.classFlag1 = true;
      } else {
        this.classFlag1 = false;
      }
    },
    handleFailureResultImgChange(file, fileList) {
      this.handlingFileList.push(file);
      this.uploadImage(file, fileList, this.handlingFileList);
      if (fileList.length > 0) {
        // 显示清除按钮
        this.clearImgFlag1 = true;
      } else {
        this.clearImgFlag1 = false;
      }
      if (this.handlingImgFileList.length > 0) {
        this.handlingImgText = "重新上传图片";
      } else {
        this.handlingImgText = "上传图片";
      }
      // 控制上传按钮隐藏
      if (fileList.length >= 10) {
        this.classFlagImg1 = true;
      } else {
        this.classFlagImg1 = false;
      }
    },
    /** 故障处理后上传照片/视频 end */

    // 大图预览
    handlePreview(file) {
      let fileType = file.name.split(".")[file.name.split(".").length - 1];
      if (fileType == "mp4") {
        this.videoUrl = file.url;
        this.dialogImageUrl = "";
        this.videoDialogVisible = true;
        this.imageDialogVisible = false;
      } else {
        this.videoUrl = "";
        this.dialogImageUrl = file.url;
        this.videoDialogVisible = false;
        this.imageDialogVisible = true;
      }
    },
    handleResultPreview(file) {
      let fileType = file.name.split(".")[file.name.split(".").length - 1];
      if (fileType == "mp4") {
        this.videoUrl1 = file.url;
        this.dialogImageUrl1 = "";
        this.videoDialogVisible1 = true;
        this.imageDialogVisible1 = false;
      } else {
        this.videoUrl1 = "";
        this.dialogImageUrl1 = file.url;
        this.videoDialogVisible1 = false;
        this.imageDialogVisible1 = true;
      }
    },
    // 判断上传的是否为图片和限制图片格式、大小等
    uploadImage(file, fileList, uploadList) {
      const img = file.name.substring(file.name.lastIndexOf(".") + 1);
      const isLt1M = file.size / 1024 / 1024 < 2;
      if (img != "jpg" && img != "png" && img != "jpeg") {
        this.$message.error("请上传正确的图片格式!");
        this.deleteFile(file, fileList);
        this.deleteFile(file, uploadList);
        return false;
      }
      // 可以限制图片的大小
      if (!isLt1M) {
        this.$message.error("上传图片大小不能超过2MB!");
        this.deleteFile(file, fileList);
        this.deleteFile(file, uploadList);
      }
    },
    // 判断上传的是否为视频和限制视频格式、大小等
    uploadVideo(file, fileList, uploadList) {
      let fileSize = file.size / 1024 / 1024 < 25; //控制大小  修改50的值即可
      if (
        ["video/mp4"].indexOf(file.raw.type) == -1 //控制格式
      ) {
        this.$message.error("请上传正确的视频格式!");
        this.deleteFile(file, fileList);
        this.deleteFile(file, uploadList);
        return false;
      }
      if (!fileSize) {
        this.$message.error("视频大小不能超过25MB!");
        this.deleteFile(file, fileList);
        this.deleteFile(file, uploadList);
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.addOrAditVehicleDefault-container {
  /deep/ .el-form-item {
    margin-bottom: 20px !important;
    margin-right: 20px !important;
    .el-form-item__error {
      min-width: 200px;
    }
  }
  .add-footer {
    text-align: right;
    margin-right: 40px;
  }
  .once-form {
    margin-bottom: 20px;
    .title-text {
      width: 100%;
      height: 20px;
      padding-left: 10px;
      margin-bottom: 10px;
      border-left: 3px solid #0093ff;
      font-size: 14px;
      font-weight: bold;
      color: #333;
    }
  }
  .normal-uploader {
    /deep/ .el-upload--picture-card {
      width: auto;
      height: auto;
      line-height: 0;
      border: none;
      background: #fff;
    }
    /deep/ .el-upload-list__item {
      width: 180px;
      height: 120px;
    }
    /deep/ .el-upload-list__item-actions {
      width: 180px;
      height: 120px;
    }
  }
  .avatar-uploader {
    /deep/ .el-upload--picture-card {
      width: 180px;
      height: 120px;
      line-height: 120px;
      background: #fff;
      border: none;
    }
    /deep/ .el-upload-list--picture-card .el-upload-list__item {
      width: 180px;
      height: 120px;
    }
    /deep/ .el-upload-list--picture-card .el-upload-list__item-thumbnail {
      width: 180px;
      height: 120px;
    }
  }
  /deep/ .el-input {
    width: 220px;
  }
  /deep/ .el-upload-list__item-delete {
    display: none !important;
  }

  .happen-picker {
    /deep/ .el-input__inner {
      padding-left: 15px;
    }
    /deep/ .el-input__prefix {
      left: auto;
      right: 10px;
      color: #333;
    }
    /deep/.el-input__suffix {
      .el-input__icon.el-icon-circle-close {
        line-height: 32px;
        display: none;
      }
    }
  }
  .longer-input {
    width: 100%;
    /deep/ .el-input {
      width: 100%;
    }
    /deep/ .el-form-item__content {
      width: calc(100% - 140px);
    }
  }
  /deep/ .el-button {
    width: 120px;
  }
}
.upload-dialog {
  /deep/ .el-dialog__body {
    padding: 30px 20px;
  }
}
</style>
